<template>
  <div>
    <TopHeader
      :payment_active="payment_active"
      :manual_active="manual_active"
      :show_landing_menu="show_landing_menu"
      @toggle-notice-sidebar="showNoticeSide"
      @show-my-info="showMyInfo"
    />

    <HeaderMenu
      :show-landing-menu="show_landing_menu"
      :payment-active="payment_active"
      :payment-menu="payment_menu"
      :menu-active="menu_active"
      :selected-report="selected_report"
      @reset="reset"
      @go-indicator-selector-page="goIndicatorSelectorPage"
      @go-editor-page="go_editor_page"
    />

    <!-- TODO: 상품결제 관리 임시 주석 -->
    <!-- <b-button
        class="py-1 px-2 float-right f-105"
        variant="light"
        @click="showTodoModal"
      >
        :variant="menu_active[2] == true ? 'half-bg-light' : 'light'"
        <b-icon icon="geo-alt"/>
      </b-button> -->

    <b-tooltip :show="is_confirmed != true" target="my-info" triggers="hover">
      {{ is_confirmed == true ? '내 계정 정보' : '이메일 계정을 인증해주세요' }}
    </b-tooltip>

    <b-modal
      id="modify-modal-top"
      ref="my-info"
      size="lg"
      title="내 계정 정보"
      centered
      :no-close-on-backdrop="!has_required_info && is_confirmed"
      :no-close-on-esc="!has_required_info && is_confirmed"
      :hide-header-close="!has_required_info && is_confirmed"
      hide-footer
    >
      <UserInfo @updateRequiredInfoFlag="updateRequiredInfoFlag" />
    </b-modal>

    <b-sidebar
      id="notice-sidebar"
      v-model="show_notice_side"
      class="bg-tealgray150"
      title="Notice"
      shadow
    >
      <div class="px-3 py-2">
        <LogAndNotice />
      </div>
    </b-sidebar>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import UserInfo from '@/components/login_components/UserInfo';
import LogAndNotice from './LogAndNotice';
import ChannelService from '@/components/ChannelService';
import Notice from './Notice.js';
import TopHeader from './TopHeader.vue';
import HeaderMenu from './HeaderMenu.vue';
import {
  LANDING_ROUTES,
  STORYBOARD_ROUTES,
  BASIC_MENU_ROUTES,
  INDICATOR_ROUTES,
  REPORT_WRITE_ROUTES,
  CHECK_REPORT_ROUTES,
  TRANSLATE_ROUTES
} from '@/components/Header/RouteConfig.js';

export default {
  name: 'Header',
  components: {
    UserInfo,
    LogAndNotice,
    TopHeader,
    HeaderMenu
  },
  mixins: [Notice],
  data() {
    return {
      has_required_info: true,
      show_landing_menu: true,
      menu_active: [true, false, false, false, false],
      payment_active: false,
      manual_active: false,
      payment_menu: [true, false, false, false],
      show_notice_side: false,
      selected_indicator: 'write_report',
      selected_framework: 'GRIv2021'
    };
  },
  computed: {
    ...mapState([
      'user_id',
      'is_confirmed',
      'is_admin',
      'e_mail',
      'user_name',
      'tel',
      'company_name',
      'privacy_agreement_date'
    ]),
    ...mapState(['licenseInfo']),
    ...mapState('report_list', ['report_code', 'report_list', 'standard_mode']),
    ...mapGetters('report_list', ['selected_report', 'gri_ver']),
    ...mapState('headerDropdown', ['showButtons1', 'showButtons2', 'showButtons3']),
    report_types() {
      if (this.selected_report) {
        const user_selected_report_type = Object.keys(this.selected_report.report_type).map(
          item => item.split('v')[0]
        );
        if (this.selected_report?.data_center) {
          user_selected_report_type.push('DATACENTER');
        }
        return user_selected_report_type;
      } else {
        return [];
      }
    }
  },
  methods: {
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),
    ...mapMutations('report_list', ['set_standard_mode']),
    ...mapActions('report_indicators', ['readReportTopics', 'readReportIndicators']),
    ...mapActions(['updateLicenseInfo']),
    ...mapActions('headerDropdown', [
      'toggleButtons1',
      'toggleButtons2',
      'toggleButtons3',
      'reset'
    ]),
    ...mapActions('logs', ['read_logs_report_code']),

    updateRequiredInfoFlag(flag) {
      this.has_required_info = flag;
    },
    goIndicatorSelectorPage() {
      const first_type = Object.keys(this.selected_report.report_type)[0];
      if (first_type === 'GRIv2021' || first_type === 'GRIv2016') {
        this.set_standard_mode('GRI');
        this.pageGo({ name: 'GetGriRecommendations' });
      } else if (first_type === 'SASBv2023') {
        this.set_standard_mode('SASB');
        this.pageGo({ name: 'GetSasbRecommendations' });
      } else if (first_type === 'TCFDv2021') {
        this.set_standard_mode('TCFD');
        this.pageGo({ name: 'GetTcfdRecommendations' });
      }
      this.reset();
    },
    switch_framework(e) {
      if (e.target.tagName !== 'A') return;
      this.selected_framework = e.target.href.split('#')[1];

      if (this.selected_framework == 'GRI') {
        this.set_standard_mode('GRI');
        this.$router.push({ name: 'SelectGriIndicators' });
      } else if (this.selected_framework == 'SASB') {
        this.set_standard_mode('SASB');
        this.$router.push({ name: 'SelectSasbIndicators' });
      } else if (this.selected_framework == 'TCFD') {
        this.set_standard_mode('TCFD');
        this.$router.push({ name: 'SelectTcfdIndicators' });
      } else if (this.selected_framework == 'DATA_CENTER') {
        this.set_standard_mode('DATA_CENTER');
        this.$router.push({ name: 'EditDCToC' });
      }
    },
    translate_all_indicators() {
      this.set_standard_mode('');
      this.$router.push('BasicTranslateSet');
    },
    switch_translate_framework(e) {
      if (e.target.tagName !== 'A') return;
      this.selected_framework = e.target.href.split('#')[1];

      if (this.selected_framework === 'GRI') {
        this.set_standard_mode('GRI');
        this.$router.push({ name: 'GriTranslateSet' });
      } else if (this.selected_framework === 'SASB') {
        this.set_standard_mode('SASB');
        this.$router.push({ name: 'SasbTranslateSet' });
      } else if (this.selected_framework === 'TCFD') {
        this.set_standard_mode('TCFD');
        this.$router.push({ name: 'TcfdTranslateSet' });
      } else if (this.selected_framework === 'DATA_CENTER') {
        this.set_standard_mode('DATA_CENTER');
        this.$router.push({ name: 'DataCenterTranslateSet' });
      }
    },

    go_editor_page() {
      if (!this.selected_report) return;
      const first_type = Object.keys(this.selected_report.report_type)[0];
      if (first_type === 'GRIv2021') {
        this.set_standard_mode('GRI');
        this.$router.push({ name: 'Gri2' });
      } else if (first_type === 'GRIv2016') {
        this.set_standard_mode('GRI');
        this.$router.push({ name: 'Gri100' });
      } else if (first_type === 'SASBv2023') {
        this.set_standard_mode('SASB');
        this.$router.push({ name: 'WriteSasb' });
      } else if (first_type === 'TCFDv2021') {
        this.set_standard_mode('TCFD');
        this.$router.push({ name: 'WriteTcfd' });
      }
      this.reset();
    },

    pageGo(to) {
      if (this.selected_report) {
        if (
          to.name === 'GetGriRecommendations' ||
          to.name === 'GetSasbRecommendations' ||
          to.name === 'GetTcfdRecommendations'
        ) {
          if (this.selected_report.state < 1) {
            this.$router.push(to);
          } else if (this.selected_report.state >= 1) {
            this.readReportTopics({ report_code: this.report_code });
            this.readReportIndicators({ report_code: this.report_code });

            if (this.standard_mode === 'GRI') this.$router.push({ name: 'SelectGriIndicators' });
            else if (this.standard_mode === 'SASB')
              this.$router.push({ name: 'SelectSasbIndicators' });
            else if (this.standard_mode === 'Tcfd')
              this.$router.push({ name: 'SelectTcfdIndicators' });
          } else {
            alert(`보고서 기본 정보를 입력하고 보고서를 생성해 주세요.`);
          }
        } else if (to.name == 'Gri100') {
          if (this.gri_ver != 'GRIv2021') {
            this.$router.push(to);
          } else {
            this.$router.push({ name: 'Gri2' });
          }
        } else if (to.name == 'CheckReport') {
          if (this.selected_report.state >= 2) {
            this.$router.push(to);
          } else {
            alert(`보고 내용을 최소 1개 이상 작성 후 검토 및 검증 가능합니다.`);
          }
        } else if (to.name == 'BasicTranslateSet') {
          this.$router.push(to);
        } else if (to.name == 'StoryBoardTranslateSet') {
          this.$router.push(to);
        }
      }
    },
    showMyInfo() {
      this.$refs['my-info'].show();
    },
    hideMyInfoModal() {
      this.$refs['my-info'].hide();
    },
    showTodoModal() {
      this.$refs['todo-modal'].show();
    },
    hideTodoModal() {
      this.$refs['todo-modal'].hide();
    },
    showNoticeSide() {
      if (this.report_code != '') {
        this.read_logs_report_code({ report_codes: [this.report_code] });
      } else {
        const target_report_codes = [];
        this.report_list.forEach(item => target_report_codes.push(item.report_code));
        this.read_logs_report_code({ report_codes: target_report_codes });
      }
      this.show_notice_side = !this.show_notice_side;
    },

    checkIsReadAndShowNotice() {
      if (!this.isRead && this.$route.name === 'Main') {
        this.show_notice_side = true;
      }
    },

    handleNoticeReadEvent() {
      this.isRead = true;
      this.show_notice_side = false;
    }
  },
  watch: {
    selected_report: {
      immediate: true,
      handler(newVal) {
        // report_type이 없으면 건너뛰기
        if (!newVal || !newVal.report_type) return;
        this.selected_framework = Object.keys(newVal.report_type)[0];
      }
    },
    show_notice_side(newValue) {
      if (!newValue) {
        this.handleNoticeReadEvent();
      }
    },
    $route: {
      immediate: true,
      handler(to) {
        this.updateLicenseInfo(); // 사용자 결제정보 상시 업데이트
        const default_menu_active = Array(5).fill(false);

        this.menu_active = default_menu_active;
        if (STORYBOARD_ROUTES.includes(to.name)) {
          this.set_standard_mode('STORYBOARD');
        } else {
          // this.update_selected_lv1({lv1_info: null});
          // this.update_selected_lv2({lv2_info: null});
        }
        if (!LANDING_ROUTES.includes(to.name)) {
          this.show_landing_menu = false;
          this.payment_active = false;
          if (BASIC_MENU_ROUTES.includes(to.name)) {
            default_menu_active[0] = true;
            this.menu_active = default_menu_active;
          }
          if (INDICATOR_ROUTES.includes(to.name)) {
            default_menu_active[1] = true;
            this.menu_active = default_menu_active;
          }
          if (REPORT_WRITE_ROUTES.includes(to.name)) {
            default_menu_active[2] = true;
            this.menu_active = default_menu_active;

            if (['WriteDataCenters', 'WriteTcfd', 'WriteSasb', 'Gri2'].includes(to.name)) {
              this.selected_indicator = 'write_report';

              if (to.name === 'WriteSasb') {
                this.set_standard_mode('SASB');
              } else if (to.name === 'WriteTcfd') {
                this.set_standard_mode('TCFD');
              } else if (to.name === 'Gri2') {
                this.set_standard_mode('GRI');
              }
            }
          }
          if (CHECK_REPORT_ROUTES.includes(to.name)) {
            default_menu_active[3] = true;
            this.menu_active = default_menu_active;
          }
          if (TRANSLATE_ROUTES.includes(to.name)) {
            if (to.name === 'BasicTranslateSet') {
              this.set_standard_mode('');
            }
            default_menu_active[4] = true;
            this.menu_active = default_menu_active;
          }
        } else if (to.name == 'PaymentService') {
          this.show_landing_menu = true;
          this.payment_menu = [true, false, false, false];
          this.payment_active = true;
        } else if (to.name == 'UserPaymentCheck') {
          this.show_landing_menu = true;
          this.payment_menu = [false, true, false, false];
          this.payment_active = true;
        } else if (to.name == 'ProductPay') {
          this.show_landing_menu = true;
          this.payment_menu = [false, false, true, false];
          this.payment_active = true;
        } else this.payment_active = false;
      }
    }
  },
  created() {
    ChannelService.boot();
    this.checkIsReadAndShowNotice();

    this.$on('notice-read', this.handleNoticeReadEvent);
  },
  mounted() {
    // 소속 회사명, 개인정보 제공 동의 여부 받기
    const tel = this.tel && this.tel.trim() !== '' ? this.tel.trim() : null;
    const company_name =
      this.company_name && this.company_name.trim() !== '' ? this.company_name.trim() : null;

    const user_name = this.user_name && this.user_name.trim() !== '' ? this.user_name.trim() : null;
    if (!tel || !company_name || !this.privacy_agreement_date || !user_name) {
      this.has_required_info = false;
      this.$refs['my-info'].show();
    }
  }
};
</script>

<style></style>
